import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconSearch = /*@__PURE__*/ proxyCustomElement(class CosmosIconSearch extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '28998086a3430ddb5e2b97ad67f9ff36f9719755', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'eaaba0f3343fcc52424e082eda3554115aa8b820', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '66ee4ee058e0e989cda1a8770cd8f574eba0f26c', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M9 3a6 6 0 1 0 0 12A6 6 0 0 0 9 3m0 1.5A4.5 4.5 0 1 1 4.5 9 4.51 4.51 0 0 1 9 4.5m5.825 10.683a.5.5 0 0 0 0 .707l3.295 3.295a.5.5 0 0 0 .707 0l.354-.354a.5.5 0 0 0 0-.707l-3.295-3.295a.5.5 0 0 0-.707 0z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-search", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-search"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-search":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconSearch);
            }
            break;
    } });
}

export { CosmosIconSearch as C, defineCustomElement as d };
